var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB7878(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 544.021,
    height: 301.989,
    viewBox: "0 0 544.021 301.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AVION",
    transform: "translate(-808.073 -166.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_32",
    "data-name": "Union 32",
    d: "M-15306.424-4151.185s17.242-12.155,29.6-28.529a129.62,129.62,0,0,1-36.35,1.38c-6.884-.815-8.783-3.168-8.783-3.168s-.092-23.637,0-23.687c5.884-5.307,21.733-5.018,32.6-4.564,9.406.388,24.191,3.522,28,4.357,15.489-27.567,38.465-69.6,38.465-69.6h52.643l-16.146,45.456-3.271,10.644h5.813s9.6,2.084,9.5,3.622-6.609,2.626-10.594,2.715-6.671,0-6.671,0v-.005L-15196.4-4197v9.7h4.03s5.434,1.9,5.164,2.626-2.707,1.788-5.979,1.992c-1.786.109-2.729.172-3.215.206v31.288Z",
    transform: "translate(16298.564 4442)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_38",
    "data-name": "Union 38",
    d: "M-14788.575-4072a5.436,5.436,0,0,1-4.61-2.684l-61.408-77.85c-4.032.551-9.2,1.166-15.794,1.821-25.3,2.515-60.222,3.9-74.691,3.9v-.377c14.462,0,49.366-1.388,74.653-3.9,22.325-2.219,28.351-4.022,29.22-4.318v-36.261c-.869-.3-6.895-2.1-29.22-4.318-25.287-2.511-60.191-3.9-74.653-3.9v-.376c14.47,0,49.393,1.388,74.691,3.9,6.622.658,11.806,1.276,15.845,1.83l61.357-77.786a5.436,5.436,0,0,1,4.61-2.684h9.425l-28.9,97.583h-.088a19.721,19.721,0,0,1,4.033,1.95,139.425,139.425,0,0,1,19.016,1.673h-.016a.023.023,0,0,1,.016,0h0c.415.084.719.342.719.657,0,.373-.446.677-.992.685-1.8.146-11.844.388-11.844.388l.05-.007a66.384,66.384,0,0,1-6.952.007,19.682,19.682,0,0,1-4.095,1.977l29.047,98.086Zm-447.248-74.811v-6.995l-.02,6.8c-7.768-.431-23.091-4.007-41.994-8.014-15.7-3.326-32.478-10.083-37.712-12.278l-1.557-.692c-2.323-1.019-4.9-2.884-4.9-5.545s2.661-4.445,4.949-5.545c0,0,20.465-8.979,39.368-12.986,18.8-3.983,34.058-7.541,41.86-8.006v-.192h290.641v.376h-290.264v52.7h290.264v.377Zm450.74-26.982a0,0,0,0,0,0,0A0,0,0,0,1-14785.083-4173.79Z",
    transform: "translate(16130.574 4491.03)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M265.751,460.417l-10.651,1.53s-.245.551.857,1.347,1.653,1.347,3.55.98,6.244-1.469,6.244-1.469Z",
    transform: "translate(587.667 -158.607)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M265.751,535.429,255.1,533.9s-.245-.551.857-1.347,1.653-1.347,3.55-.98,6.244,1.469,6.244,1.469Z",
    transform: "translate(587.667 -202.825)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M240.4,471.207s-7.074,11.6,0,22.628c0-.165,4.981-1.433,4.981-1.433s-5.141-9.592,0-19.922Z",
    transform: "translate(598.769 -165.314)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M696.8,309.745s-4.1.166-11.8.438-22.91-.091-26.17,3.441,4.8,4.528,12.587,5.162,18.383.543,18.383.543c.588,0,1.027-.011,1.38-.039.177-.014.331-.032.472-.055h.008a3.812,3.812,0,0,0,.4-.087,21.519,21.519,0,0,0,6.566-2.892h0a27.234,27.234,0,0,0,4.576-3.154C704.928,311.579,696.8,309.745,696.8,309.745Z",
    transform: "translate(336.732 -64.898)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_33",
    "data-name": "Union 33",
    d: "M-15222.9-4151.189s-22.976-42.033-38.465-69.6c-3.811.838-18.6,3.968-28,4.361-10.863.454-26.713.742-32.6-4.564-.092-.054,0-23.687,0-23.687s1.9-2.353,8.783-3.168a129.658,129.658,0,0,1,36.35,1.38c-12.355-16.373-29.6-28.528-29.6-28.528h110.022v31.285c.486.035,1.429.1,3.215.208,3.272.2,5.706,1.269,5.979,1.992s-5.164,2.626-5.164,2.626h-4.03v9.7l4.8,15.605-.012-.043s2.688-.089,6.671,0,10.506,1.176,10.594,2.718-9.5,3.623-9.5,3.623h-5.813l3.271,10.644,16.146,45.452Z",
    transform: "translate(16298.564 4619.177)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M696.8,678.357s-4.1-.166-11.8-.437-22.91.09-26.17-3.442,4.8-4.528,12.587-5.161,18.383-.544,18.383-.544c.588,0,1.027.011,1.38.039.177.014.331.032.472.055h.008a3.722,3.722,0,0,1,.4.087,21.5,21.5,0,0,1,6.566,2.892h0A27.234,27.234,0,0,1,703.207,675C704.928,676.523,696.8,678.357,696.8,678.357Z",
    transform: "translate(336.732 -288.215)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M1163.364,431.611",
    transform: "translate(22.081 -140.679)",
    fill: "none",
    stroke: "#6b6b6b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M516.9,485.764H410.439V441.138H516.9Zm-106.083-.377H516.522V441.515H410.816Z",
    transform: "translate(490.942 -146.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M516.9,489.714H410.439V452.452H516.9Zm-106.083-.377H516.522V452.829H410.816Z",
    transform: "translate(490.942 -153.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M553.644,489.834H469.437V452.571h84.207Zm-83.83-.377h83.453V452.948H469.814Z",
    transform: "translate(454.203 -153.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M1168.394,485.764h-87.317V441.138h87.317Zm-86.939-.377h86.562V441.515h-86.562Z",
    transform: "translate(73.341 -146.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M1332.984,488.437h-21.411V455.7h21.411Zm-21.034-.377h20.657V456.081H1311.95Z",
    transform: "translate(-70.205 -155.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M1168.394,488.19h-87.317V452.452h87.317Zm-86.939-.377h86.562V452.829h-86.562Z",
    transform: "translate(73.341 -153.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    "data-name": "Rectangle 770",
    width: 0.377,
    height: 36.886,
    transform: "translate(944.674 299.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    "data-name": "Rectangle 771",
    width: 0.377,
    height: 36.886,
    transform: "translate(965.561 299.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_772",
    "data-name": "Rectangle 772",
    width: 0.377,
    height: 36.886,
    transform: "translate(986.448 299.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    width: 0.377,
    height: 35.361,
    transform: "translate(1176.414 299.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 0.377,
    height: 35.361,
    transform: "translate(1198.674 299.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 0.377,
    height: 35.361,
    transform: "translate(1213.311 299.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 0.377,
    height: 35.361,
    transform: "translate(1226.727 299.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 42.677,
    height: 0.377,
    transform: "translate(1198.873 316.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1418",
    "data-name": "Group 1418",
    transform: "translate(906.489 314.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M425.284,494.757c.866,0,1.316.449,1.316,1.136s-.449,1.136-1.316,1.136h-.8v1.49H424v-3.762Zm-.8,1.849h.766c.571,0,.851-.27.851-.714s-.28-.713-.851-.713h-.766Z",
    transform: "translate(-423.995 -494.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M436.074,498.519v-1.912c0-.476.005-.957.011-1.437h-.011c-.164.481-.338.957-.513,1.437l-.7,1.912h-.56l-.7-1.912c-.175-.481-.349-.957-.513-1.437h-.011c.005.481.011.962.011,1.437v1.912h-.476v-3.762h.782l.682,1.855c.169.475.338.967.5,1.442h.011c.158-.476.327-.967.5-1.442l.676-1.855h.787v3.762Z",
    transform: "translate(-429.366 -494.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M448.11,495.908h-.5a.937.937,0,0,0-.993-.9c-.708,0-1.141.571-1.141,1.511s.428,1.511,1.125,1.511a.988.988,0,0,0,1.025-.924h.507a1.426,1.426,0,0,1-1.532,1.368c-1.009,0-1.632-.74-1.632-1.955s.628-1.955,1.648-1.955A1.386,1.386,0,0,1,448.11,495.908Z",
    transform: "translate(-437.057 -494.56)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1419",
    "data-name": "Group 1419",
    transform: "translate(927.303 314.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M480.448,494.757c.867,0,1.316.449,1.316,1.136s-.449,1.136-1.316,1.136h-.8v1.49h-.486v-3.762Zm-.8,1.849h.766c.571,0,.851-.27.851-.714s-.28-.713-.851-.713h-.766Z",
    transform: "translate(-479.159 -494.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M491.238,498.519v-1.912c0-.476.005-.957.011-1.437h-.011c-.164.481-.338.957-.513,1.437l-.7,1.912h-.56l-.7-1.912c-.175-.481-.349-.957-.513-1.437h-.011c.005.481.011.962.011,1.437v1.912h-.476v-3.762h.782l.682,1.855c.169.475.338.967.5,1.442h.011c.158-.476.327-.967.5-1.442l.676-1.855h.787v3.762Z",
    transform: "translate(-484.53 -494.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M503.274,495.908h-.5a.937.937,0,0,0-.993-.9c-.708,0-1.141.571-1.141,1.511s.428,1.511,1.125,1.511a.988.988,0,0,0,1.025-.924h.507a1.426,1.426,0,0,1-1.532,1.368c-1.009,0-1.632-.74-1.632-1.955s.628-1.955,1.648-1.955A1.386,1.386,0,0,1,503.274,495.908Z",
    transform: "translate(-492.221 -494.56)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1420",
    "data-name": "Group 1420",
    transform: "translate(949.421 315.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M539.073,495.986c.866,0,1.315.449,1.315,1.136s-.449,1.136-1.315,1.136h-.8v1.49h-.486v-3.762Zm-.8,1.849h.766c.571,0,.851-.269.851-.713s-.28-.713-.851-.713h-.766Z",
    transform: "translate(-537.784 -495.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M549.863,499.748v-1.913c0-.475.005-.957.011-1.437h-.011c-.164.481-.338.956-.513,1.437l-.7,1.913h-.56l-.7-1.913c-.174-.481-.349-.957-.513-1.437h-.01c.005.481.01.962.01,1.437v1.913h-.475v-3.762h.782l.682,1.855c.169.476.338.967.5,1.442h.011c.158-.475.327-.967.5-1.442l.676-1.855h.787v3.762Z",
    transform: "translate(-543.155 -495.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M561.9,497.137h-.5a.937.937,0,0,0-.994-.9c-.708,0-1.141.57-1.141,1.511s.428,1.511,1.125,1.511a.988.988,0,0,0,1.025-.924h.507a1.426,1.426,0,0,1-1.533,1.368c-1.009,0-1.632-.74-1.632-1.955s.629-1.955,1.648-1.955A1.386,1.386,0,0,1,561.9,497.137Z",
    transform: "translate(-550.845 -495.79)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421",
    transform: "translate(970.419 315.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M594.728,495.986c.866,0,1.316.449,1.316,1.136s-.449,1.136-1.316,1.136h-.8v1.49h-.486v-3.762Zm-.8,1.849h.766c.571,0,.851-.269.851-.713s-.28-.713-.851-.713h-.766Z",
    transform: "translate(-593.439 -495.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M605.518,499.748v-1.913c0-.475.005-.957.011-1.437h-.011c-.164.481-.338.956-.513,1.437l-.7,1.913h-.56l-.7-1.913c-.175-.481-.349-.957-.513-1.437h-.011c.005.481.011.962.011,1.437v1.913h-.476v-3.762h.782l.682,1.855c.169.476.338.967.5,1.442h.011c.158-.475.327-.967.5-1.442l.676-1.855h.788v3.762Z",
    transform: "translate(-598.81 -495.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M617.554,497.137h-.5a.937.937,0,0,0-.993-.9c-.708,0-1.141.57-1.141,1.511s.428,1.511,1.126,1.511a.988.988,0,0,0,1.025-.924h.507a1.426,1.426,0,0,1-1.532,1.368c-1.009,0-1.632-.74-1.632-1.955s.628-1.955,1.648-1.955A1.385,1.385,0,0,1,617.554,497.137Z",
    transform: "translate(-606.501 -495.79)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422",
    transform: "translate(992.387 315.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M652.952,495.986c.866,0,1.315.449,1.315,1.136s-.449,1.136-1.315,1.136h-.8v1.49h-.486v-3.762Zm-.8,1.849h.766c.571,0,.851-.269.851-.713s-.28-.713-.851-.713h-.766Z",
    transform: "translate(-651.663 -495.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M663.742,499.748v-1.913c0-.475.005-.957.01-1.437h-.01c-.164.481-.338.956-.513,1.437l-.7,1.913h-.56l-.7-1.913c-.174-.481-.348-.957-.512-1.437h-.01c.005.481.01.962.01,1.437v1.913h-.475v-3.762h.782l.682,1.855c.169.476.338.967.5,1.442h.011c.158-.475.327-.967.5-1.442l.676-1.855h.787v3.762Z",
    transform: "translate(-657.034 -495.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M675.778,497.137h-.5a.937.937,0,0,0-.993-.9c-.708,0-1.141.57-1.141,1.511s.428,1.511,1.125,1.511a.988.988,0,0,0,1.025-.924h.507a1.426,1.426,0,0,1-1.532,1.368c-1.009,0-1.632-.74-1.632-1.955s.629-1.955,1.648-1.955A1.386,1.386,0,0,1,675.778,497.137Z",
    transform: "translate(-664.724 -495.79)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1423",
    "data-name": "Group 1423",
    transform: "translate(1160.447 315.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M1098.389,495.867c.866,0,1.315.449,1.315,1.136s-.449,1.136-1.315,1.136h-.8v1.49h-.486v-3.762Zm-.8,1.849h.766c.571,0,.851-.27.851-.713s-.28-.713-.851-.713h-.766Z",
    transform: "translate(-1097.1 -495.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M1104.454,498.509l-.412,1.12h-.518l1.427-3.762h.661l1.432,3.762h-.523l-.407-1.12Zm1.379-.771c-.19-.523-.364-1.009-.544-1.532h-.01c-.18.523-.354,1.009-.545,1.532l-.127.343h1.348Z",
    transform: "translate(-1101.101 -495.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M1116.4,496.876h-.518a.9.9,0,0,0-.977-.761c-.74,0-1.194.576-1.194,1.522s.439,1.522,1.157,1.522c.613,0,1.062-.349,1.068-1.231h-1.036v-.417h1.5v2h-.433v-.518h-.011a1.319,1.319,0,0,1-1.184.586c-.961,0-1.569-.734-1.569-1.939,0-1.221.65-1.965,1.7-1.965A1.347,1.347,0,0,1,1116.4,496.876Z",
    transform: "translate(-1107.127 -495.671)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1424",
    "data-name": "Group 1424",
    transform: "translate(1182.629 315.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M1157.181,495.867c.866,0,1.315.449,1.315,1.136s-.449,1.136-1.315,1.136h-.8v1.49h-.486v-3.762Zm-.8,1.849h.766c.571,0,.851-.27.851-.713s-.28-.713-.851-.713h-.766Z",
    transform: "translate(-1155.892 -495.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M1167.971,499.629v-1.913c0-.475,0-.957.01-1.437h-.01c-.164.481-.338.956-.513,1.437l-.7,1.913h-.56l-.7-1.913c-.174-.481-.349-.957-.513-1.437h-.011c.006.481.011.962.011,1.437v1.913h-.475v-3.762h.782l.682,1.855c.169.476.338.967.5,1.442h.011c.158-.476.327-.967.5-1.442l.676-1.855h.788v3.762Z",
    transform: "translate(-1161.263 -495.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M1180.006,497.018h-.5a.937.937,0,0,0-.993-.9c-.708,0-1.141.571-1.141,1.511s.428,1.511,1.125,1.511a.987.987,0,0,0,1.025-.924h.507a1.426,1.426,0,0,1-1.532,1.368c-1.009,0-1.632-.74-1.632-1.955s.628-1.955,1.648-1.955A1.385,1.385,0,0,1,1180.006,497.018Z",
    transform: "translate(-1168.953 -495.671)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1425",
    "data-name": "Group 1425",
    transform: "translate(1200.566 307.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M1204.366,477.1l-.412,1.12h-.518l1.427-3.762h.66l1.432,3.762h-.523l-.407-1.12Zm1.379-.771c-.191-.523-.365-1.009-.545-1.533h-.01c-.18.523-.354,1.009-.544,1.533l-.127.343h1.347Z",
    transform: "translate(-1203.436 -474.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M1216.645,478.223H1216l-1.632-1.849h-.011v1.849h-.486v-3.762h.486v1.7h.011l1.516-1.7h.613l-1.643,1.791Z",
    transform: "translate(-1209.932 -474.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M1222.823,474.894v1.189h1.828v.428h-1.828v1.279h2v.433h-2.483v-3.762h2.425v.433Z",
    transform: "translate(-1215.208 -474.461)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1426",
    "data-name": "Group 1426",
    transform: "translate(1200.566 322.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M1204.366,518.2l-.412,1.12h-.518l1.427-3.762h.66l1.432,3.762h-.523l-.407-1.12Zm1.379-.771c-.191-.523-.365-1.009-.545-1.532h-.01c-.18.523-.354,1.009-.544,1.532l-.127.343h1.347Z",
    transform: "translate(-1203.436 -515.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M1216.645,519.322H1216l-1.632-1.849h-.011v1.849h-.486V515.56h.486v1.7h.011l1.516-1.7h.613l-1.643,1.791Z",
    transform: "translate(-1209.932 -515.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M1222.823,515.993v1.189h1.828v.428h-1.828v1.279h2v.433h-2.483V515.56h2.425v.433Z",
    transform: "translate(-1215.208 -515.56)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1427",
    "data-name": "Group 1427",
    transform: "translate(1215.373 307.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M1243.609,477.1l-.412,1.12h-.518l1.427-3.762h.661l1.432,3.762h-.523l-.407-1.12Zm1.379-.771c-.191-.523-.365-1.009-.545-1.533h-.01c-.179.523-.354,1.009-.544,1.533l-.127.343h1.347Z",
    transform: "translate(-1242.679 -474.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M1255.888,478.223h-.65l-1.633-1.849h-.01v1.849h-.486v-3.762h.486v1.7h.01l1.516-1.7h.613l-1.643,1.791Z",
    transform: "translate(-1249.175 -474.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M1262.066,474.894v1.189h1.828v.428h-1.828v1.279h2v.433h-2.483v-3.762h2.425v.433Z",
    transform: "translate(-1254.451 -474.461)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1428",
    "data-name": "Group 1428",
    transform: "translate(1215.373 322.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M1243.609,518.2l-.412,1.12h-.518l1.427-3.762h.661l1.432,3.762h-.523l-.407-1.12Zm1.379-.771c-.19-.523-.365-1.009-.544-1.532h-.01c-.18.523-.354,1.009-.544,1.532l-.127.343h1.347Z",
    transform: "translate(-1242.679 -515.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M1255.888,519.322h-.65l-1.633-1.849h-.01v1.849h-.486V515.56h.486v1.7h.01l1.516-1.7h.613l-1.643,1.791Z",
    transform: "translate(-1249.175 -515.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M1262.065,515.993v1.189h1.828v.428h-1.828v1.279h2v.433h-2.483V515.56H1264v.433Z",
    transform: "translate(-1254.45 -515.56)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1429",
    "data-name": "Group 1429",
    transform: "translate(1229.586 307.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M1281.283,476.85l-.412,1.12h-.518l1.427-3.762h.661l1.432,3.762h-.523l-.407-1.12Zm1.379-.771c-.19-.523-.365-1.009-.545-1.533h-.01c-.18.523-.354,1.009-.544,1.533l-.127.343h1.348Z",
    transform: "translate(-1280.353 -474.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M1293.562,477.97h-.649l-1.633-1.849h-.011v1.849h-.486v-3.762h.486v1.7h.011l1.516-1.7h.613L1291.766,476Z",
    transform: "translate(-1286.849 -474.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M1299.74,474.641v1.189h1.828v.428h-1.828v1.279h2v.433h-2.483v-3.762h2.425v.433Z",
    transform: "translate(-1292.125 -474.208)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430",
    transform: "translate(1229.586 322.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M1281.283,517.949l-.412,1.12h-.518l1.427-3.762h.661l1.432,3.762h-.523l-.407-1.12Zm1.379-.771c-.19-.523-.365-1.009-.545-1.532h-.01c-.18.523-.354,1.009-.544,1.532l-.127.344h1.348Z",
    transform: "translate(-1280.353 -515.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M1293.562,519.069h-.649l-1.633-1.849h-.011v1.849h-.486v-3.762h.486V517h.011l1.516-1.7h.613l-1.643,1.791Z",
    transform: "translate(-1286.849 -515.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M1299.74,515.74v1.189h1.828v.428h-1.828v1.279h2v.433h-2.483v-3.762h2.425v.433Z",
    transform: "translate(-1292.125 -515.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431",
    transform: "translate(1245.984 314.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M1325.041,492.762c.867,0,1.268.385,1.268.956a.878.878,0,0,1-.624.877v.01a.853.853,0,0,1,.708.883c0,.629-.459,1.035-1.252,1.035h-1.327v-3.762Zm-.74,1.643h.7c.591,0,.824-.238.824-.618,0-.4-.238-.613-.8-.613h-.724Zm0,1.706h.771c.555,0,.819-.227.819-.649,0-.407-.258-.65-.887-.65h-.7Z",
    transform: "translate(-1323.815 -492.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M1335.159,495.113a1.4,1.4,0,1,1-2.79,0v-2.351h.486V495.1c0,.7.338,1.051.909,1.051s.9-.349.9-1.051v-2.341h.491Z",
    transform: "translate(-1329.143 -492.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M1344.733,496.091v.433h-2.41v-3.762h.486v3.329Z",
    transform: "translate(-1335.342 -492.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M1352.956,496.524h-.65l-1.632-1.849h-.011v1.849h-.486v-3.762h.486v1.7h.011l1.516-1.7h.613l-1.643,1.791Z",
    transform: "translate(-1340.234 -492.762)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 19.814,
    height: 10.658,
    transform: "translate(923.824 286.37)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 19.814,
    height: 10.658,
    transform: "translate(1203.594 286.37)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    "data-name": "Rectangle 780",
    width: 13.468,
    height: 13.468,
    transform: "translate(1245.484 330.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432",
    transform: "translate(927.335 290.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M480.343,431.664a1.881,1.881,0,1,1,0,3.762h-1.1v-3.762Zm-.756,3.45h.756a1.569,1.569,0,0,0,0-3.138h-.756Z",
    transform: "translate(-479.244 -431.595)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M491.086,433.432c0,1.189-.65,1.949-1.67,1.949s-1.675-.76-1.675-1.949.655-1.95,1.675-1.95S491.086,432.243,491.086,433.432Zm-2.98,0c0,.993.507,1.627,1.31,1.627s1.311-.634,1.311-1.627-.513-1.627-1.311-1.627S488.106,432.438,488.106,433.432Z",
    transform: "translate(-484.536 -431.482)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M500.45,433.432c0,1.189-.65,1.949-1.67,1.949s-1.675-.76-1.675-1.949.655-1.95,1.675-1.95S500.45,432.243,500.45,433.432Zm-2.98,0c0,.993.507,1.627,1.31,1.627s1.311-.634,1.311-1.627-.513-1.627-1.311-1.627S497.471,432.438,497.471,433.432Z",
    transform: "translate(-490.369 -431.482)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M508.08,431.664c.887,0,1.289.375,1.289,1a.917.917,0,0,1-.729.946v.011c.28.084.4.243.56.7l.4,1.1h-.375l-.359-1.046c-.164-.47-.349-.613-.766-.613h-.777v1.659h-.343v-3.762Zm-.761,1.791h.782c.64,0,.92-.338.914-.782,0-.476-.338-.7-.94-.7h-.755Z",
    transform: "translate(-496.516 -431.595)",
    fill: "#b00927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433",
    transform: "translate(1207.742 290.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M1223.55,431.663a1.881,1.881,0,1,1,0,3.762h-1.1v-3.762Zm-.755,3.45h.755a1.569,1.569,0,0,0,0-3.138h-.755Z",
    transform: "translate(-1222.451 -431.594)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M1234.292,433.431c0,1.189-.649,1.949-1.669,1.949s-1.675-.76-1.675-1.949.656-1.95,1.675-1.95S1234.292,432.242,1234.292,433.431Zm-2.98,0c0,.993.507,1.627,1.31,1.627s1.31-.634,1.31-1.627-.513-1.627-1.31-1.627S1231.313,432.437,1231.313,433.431Z",
    transform: "translate(-1227.743 -431.481)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M1243.658,433.431c0,1.189-.65,1.949-1.67,1.949s-1.675-.76-1.675-1.949.656-1.95,1.675-1.95S1243.658,432.242,1243.658,433.431Zm-2.98,0c0,.993.507,1.627,1.31,1.627s1.311-.634,1.311-1.627-.513-1.627-1.311-1.627S1240.678,432.437,1240.678,433.431Z",
    transform: "translate(-1233.576 -431.481)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M1251.288,431.663c.888,0,1.289.375,1.289,1a.916.916,0,0,1-.729.946v.011c.28.084.4.243.56.7l.4,1.1h-.375l-.359-1.046c-.164-.47-.349-.613-.766-.613h-.777v1.659h-.343v-3.762Zm-.761,1.791h.782c.639,0,.919-.338.914-.782,0-.476-.338-.7-.94-.7h-.755Z",
    transform: "translate(-1239.724 -431.594)",
    fill: "#b00927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1434",
    "data-name": "Group 1434",
    transform: "translate(1246.018 335.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M1325,548.977a1.882,1.882,0,1,1,0,3.762h-1.1v-3.762Zm-.755,3.451H1325a1.569,1.569,0,0,0,0-3.139h-.755Z",
    transform: "translate(-1323.9 -548.909)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M1335.742,550.746c0,1.189-.65,1.949-1.67,1.949s-1.675-.761-1.675-1.949.656-1.95,1.675-1.95S1335.742,549.556,1335.742,550.746Zm-2.98,0c0,.993.507,1.627,1.31,1.627s1.311-.634,1.311-1.627-.513-1.628-1.311-1.628S1332.762,549.752,1332.762,550.746Z",
    transform: "translate(-1329.192 -548.796)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M1345.107,550.746c0,1.189-.65,1.949-1.67,1.949s-1.675-.761-1.675-1.949.655-1.95,1.675-1.95S1345.107,549.556,1345.107,550.746Zm-2.98,0c0,.993.507,1.627,1.31,1.627s1.311-.634,1.311-1.627-.513-1.628-1.311-1.628S1342.127,549.752,1342.127,550.746Z",
    transform: "translate(-1335.025 -548.796)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M1352.738,548.977c.887,0,1.289.375,1.289,1a.916.916,0,0,1-.729.946v.011c.28.084.4.243.56.7l.4,1.1h-.375l-.359-1.046c-.164-.471-.349-.613-.766-.613h-.777v1.659h-.343v-3.762Zm-.761,1.791h.782c.64,0,.92-.338.914-.782,0-.476-.338-.7-.94-.7h-.755Z",
    transform: "translate(-1341.173 -548.909)",
    fill: "#b00927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1435",
    "data-name": "Group 1435",
    transform: "translate(924.361 280.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M471.7,404.132v1.421h1.828v.312H471.7v1.717h-.343V403.82h2.288v.312Z",
    transform: "translate(-471.353 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M481.865,405.588c0,1.189-.65,1.949-1.67,1.949s-1.675-.76-1.675-1.949.655-1.95,1.675-1.95S481.865,404.4,481.865,405.588Zm-2.98,0c0,.993.507,1.627,1.31,1.627s1.311-.634,1.311-1.627-.513-1.627-1.311-1.627S478.884,404.595,478.884,405.588Z",
    transform: "translate(-475.817 -403.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M490.544,403.82c.888,0,1.289.375,1.289,1a.916.916,0,0,1-.729.946v.011c.28.084.4.243.56.7l.4,1.1h-.375l-.36-1.046c-.163-.47-.348-.613-.766-.613h-.777v1.659h-.344V403.82Zm-.761,1.791h.782c.639,0,.919-.338.914-.782,0-.476-.338-.7-.94-.7h-.756Z",
    transform: "translate(-482.618 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M499.907,407.582l-.422-1.717c-.143-.576-.286-1.152-.423-1.728h-.011c-.137.576-.28,1.152-.423,1.728l-.422,1.717h-.539l-.92-3.762h.349l.391,1.6c.153.613.3,1.226.449,1.839h.011c.153-.613.3-1.236.454-1.849l.391-1.591h.528l.391,1.591c.154.613.3,1.236.454,1.849h.011l.444-1.839.4-1.6h.349l-.919,3.762Z",
    transform: "translate(-487.169 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M509.964,406.367l-.471,1.215h-.37l1.49-3.762h.47l1.485,3.762h-.37l-.47-1.215Zm1.49-.708c-.206-.534-.4-1.02-.6-1.559h-.01c-.206.539-.391,1.025-.6,1.559l-.153.391H511.6Z",
    transform: "translate(-494.877 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M520.575,403.82c.888,0,1.289.375,1.289,1a.916.916,0,0,1-.729.946v.011c.28.084.4.243.56.7l.4,1.1h-.375l-.359-1.046c-.164-.47-.349-.613-.766-.613h-.777v1.659h-.343V403.82Zm-.761,1.791h.782c.639,0,.92-.338.914-.782,0-.476-.338-.7-.94-.7h-.756Z",
    transform: "translate(-501.322 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M529.348,403.82a1.881,1.881,0,1,1,0,3.762h-1.1V403.82Zm-.755,3.45h.755a1.569,1.569,0,0,0,0-3.138h-.755Z",
    transform: "translate(-506.789 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M543.815,404.964h-.359a1.047,1.047,0,0,0-1.1-1c-.777,0-1.252.618-1.252,1.627s.47,1.627,1.242,1.627a1.105,1.105,0,0,0,1.136-1.025h.359a1.412,1.412,0,0,1-1.5,1.347c-.993,0-1.606-.74-1.606-1.949s.619-1.95,1.617-1.95A1.36,1.36,0,0,1,543.815,404.964Z",
    transform: "translate(-514.565 -403.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M550.241,406.367l-.47,1.215h-.37l1.49-3.762h.47l1.484,3.762h-.37l-.47-1.215Zm1.49-.708c-.206-.534-.4-1.02-.6-1.559h-.01c-.206.539-.391,1.025-.6,1.559l-.153.391h1.516Z",
    transform: "translate(-519.963 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M560.852,403.82c.887,0,1.289.375,1.289,1a.917.917,0,0,1-.729.946v.011c.28.084.4.243.56.7l.4,1.1h-.375l-.359-1.046c-.164-.47-.349-.613-.766-.613h-.777v1.659h-.343V403.82Zm-.761,1.791h.782c.64,0,.92-.338.914-.782,0-.476-.338-.7-.94-.7h-.755Z",
    transform: "translate(-526.407 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M570.795,404.816h-.359a1,1,0,0,0-1.1-.856c-.809,0-1.3.623-1.3,1.638s.475,1.617,1.247,1.617c.656,0,1.184-.37,1.184-1.4h-1.1V405.5H570.8v1.966h-.323v-.576h-.011a1.323,1.323,0,0,1-1.22.639c-.962,0-1.575-.729-1.575-1.934s.634-1.96,1.664-1.96A1.322,1.322,0,0,1,570.795,404.816Z",
    transform: "translate(-531.342 -403.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M581.152,405.588c0,1.189-.65,1.949-1.67,1.949s-1.675-.76-1.675-1.949.655-1.95,1.675-1.95S581.152,404.4,581.152,405.588Zm-2.98,0c0,.993.507,1.627,1.31,1.627s1.311-.634,1.311-1.627-.513-1.627-1.311-1.627S578.172,404.595,578.172,405.588Z",
    transform: "translate(-537.655 -403.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M594.4,407.582v-1.8h-2.108v1.8h-.343V403.82h.343v1.654H594.4V403.82h.344v3.762Z",
    transform: "translate(-546.462 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M604.741,405.588c0,1.189-.65,1.949-1.67,1.949s-1.675-.76-1.675-1.949.656-1.95,1.675-1.95S604.741,404.4,604.741,405.588Zm-2.98,0c0,.993.507,1.627,1.31,1.627s1.311-.634,1.311-1.627-.513-1.627-1.311-1.627S601.761,404.595,601.761,405.588Z",
    transform: "translate(-552.346 -403.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M614.652,407.27v.312h-2.335V403.82h.344v3.45Z",
    transform: "translate(-559.148 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M621.159,403.82a1.881,1.881,0,1,1,0,3.762h-1.1V403.82Zm-.756,3.45h.756a1.569,1.569,0,0,0,0-3.138H620.4Z",
    transform: "translate(-563.97 -403.751)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1436",
    "data-name": "Group 1436",
    transform: "translate(1167.018 280.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M1115.338,406.367l-.47,1.216h-.37l1.49-3.762h.47l1.485,3.762h-.37l-.47-1.216Zm1.49-.708c-.206-.533-.4-1.02-.6-1.559h-.01c-.206.539-.391,1.026-.6,1.559l-.153.391h1.516Z",
    transform: "translate(-1114.498 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M1125.188,404.132v1.421h1.828v.312h-1.828v1.717h-.343V403.82h2.288v.312Z",
    transform: "translate(-1120.942 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M1133.482,404.132v3.45h-.344v-3.45H1131.8v-.312h3.022v.312Z",
    transform: "translate(-1125.275 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M1146.881,404.964h-.359a1.047,1.047,0,0,0-1.1-1c-.777,0-1.252.618-1.252,1.627s.47,1.627,1.242,1.627a1.1,1.1,0,0,0,1.136-1.025h.359a1.412,1.412,0,0,1-1.495,1.347c-.993,0-1.606-.74-1.606-1.949s.618-1.95,1.617-1.95A1.361,1.361,0,0,1,1146.881,404.964Z",
    transform: "translate(-1132.748 -403.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M1153.306,406.367l-.47,1.216h-.37l1.49-3.762h.47l1.485,3.762h-.37l-.47-1.216Zm1.49-.708c-.206-.533-.4-1.02-.6-1.559h-.01c-.206.539-.391,1.026-.6,1.559l-.153.391h1.516Z",
    transform: "translate(-1138.145 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M1163.917,403.82c.888,0,1.289.376,1.289,1a.916.916,0,0,1-.729.946v.01c.28.085.4.243.56.7l.4,1.1h-.375l-.359-1.046c-.164-.471-.348-.613-.766-.613h-.777v1.659h-.343V403.82Zm-.761,1.792h.782c.639,0,.919-.338.914-.782,0-.475-.338-.7-.94-.7h-.755Z",
    transform: "translate(-1144.589 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M1173.859,404.816h-.359a1,1,0,0,0-1.1-.855c-.808,0-1.3.623-1.3,1.638s.476,1.616,1.247,1.616c.655,0,1.183-.37,1.183-1.4h-1.1V405.5h1.437v1.966h-.322v-.576h-.011a1.322,1.322,0,0,1-1.22.64c-.962,0-1.575-.729-1.575-1.934s.635-1.961,1.665-1.961A1.322,1.322,0,0,1,1173.859,404.816Z",
    transform: "translate(-1149.524 -403.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M1184.216,405.588c0,1.189-.65,1.949-1.669,1.949s-1.675-.761-1.675-1.949.655-1.95,1.675-1.95S1184.216,404.4,1184.216,405.588Zm-2.98,0c0,.993.507,1.627,1.31,1.627s1.31-.634,1.31-1.627-.513-1.627-1.31-1.627S1181.237,404.595,1181.237,405.588Z",
    transform: "translate(-1155.837 -403.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M1197.464,407.582v-1.8h-2.108v1.8h-.343V403.82h.343v1.654h2.108V403.82h.344v3.762Z",
    transform: "translate(-1164.644 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M1207.806,405.588c0,1.189-.65,1.949-1.67,1.949s-1.675-.761-1.675-1.949.655-1.95,1.675-1.95S1207.806,404.4,1207.806,405.588Zm-2.98,0c0,.993.507,1.627,1.31,1.627s1.311-.634,1.311-1.627-.512-1.627-1.311-1.627S1204.826,404.595,1204.826,405.588Z",
    transform: "translate(-1170.529 -403.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M1217.717,407.271v.312h-2.335V403.82h.343v3.451Z",
    transform: "translate(-1177.33 -403.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M1224.223,403.82a1.882,1.882,0,1,1,0,3.762h-1.1V403.82Zm-.755,3.451h.755a1.569,1.569,0,0,0,0-3.139h-.755Z",
    transform: "translate(-1182.152 -403.751)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB7878);
export default __webpack_public_path__ + "static/media/b787-8.0d441dced5d1aa29e4a9ec4b59eacefa.svg";
export { ForwardRef as ReactComponent };